"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentSettingsProvider = void 0;
const lodash_1 = __importDefault(require("lodash"));
const BaseDataProvider_1 = require("./BaseDataProvider");
class AssignmentSettingsProvider extends BaseDataProvider_1.BaseDataProvider {
    settings(id) {
        return this.docPromise(this.refs.assignmentSettings(id));
    }
    settingsStream(id) {
        return this.docDataStream(this.refs.assignmentSettings(id), true);
    }
    /** returns any assignment that matches the pincode */
    async anyByPincode(pincode) {
        const results = await this.find({ pincode });
        return lodash_1.default.first(results);
    }
    find(options) {
        return this.collectionPromise(this.query(options));
    }
    query(options) {
        let query = this.refs.assignmentSettingCollection();
        query = lodash_1.default.isNil(options.pincode) ? query : query.where('pincode', '==', options.pincode);
        query = lodash_1.default.isNil(options.limit) ? query : query.limit(options.limit);
        return query;
    }
}
exports.AssignmentSettingsProvider = AssignmentSettingsProvider;
//# sourceMappingURL=AssignmentSettingsProvider.js.map